import { defineComponent, createBlock, openBlock, resolveDynamicComponent, unref, mergeProps } from "vue";
import { useLocalization } from "./index106.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ReceiptInvoice",
  props: {
    order: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {
      }
    },
    venue: {
      type: Object,
      default: () => void 0
    },
    isRetail: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const { loadLocalizedComponent } = useLocalization();
    const ReceiptInvoiceComponent = loadLocalizedComponent("ReceiptInvoice");
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(ReceiptInvoiceComponent)), mergeProps({ class: "receipt-invoice" }, props), null, 16);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index3.js.map
